import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Header, Button, Input } from 'semantic-ui-react';
import { firebaseConnect, pathToJS, isLoaded } from 'react-redux-firebase';

class component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };
  }

  login() {
    this.props.firebase.login({ email: this.state.email, password: this.state.password });
  }

  render() {
    const { auth } = this.props;
    if (!isLoaded(auth)) return <div />;
    return (
     auth
     ? <p>Hello, {auth.email}</p>
     : <Modal trigger={<Button size="micro" compact circular icon="plus" className="menu-button" > Admin Login </Button>} size="small">
       <Header content="Login" />
       <Modal.Content>
         <Input placeholder="email" onChange={(e, data) => this.setState({ email: data.value })} fluid />
         <Input placeholder="password" onChange={(e, data) => this.setState({ password: data.value })} fluid />
       </Modal.Content>
       <Modal.Actions>
         <Button onClick={() => this.login()}>Login</Button>
       </Modal.Actions>
     </Modal>
    );
  }
}

export default connect(({ firebase }) => ({
  auth: pathToJS(firebase, 'auth'),
}))(firebaseConnect()(component));



// WEBPACK FOOTER //
// ./src/modules/LoginModalButton/component.js